import { useContext, useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "../../axios";
import { SubStdSelContext } from "../../SubStdSelContext";
import { IP } from "../../internalServer";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TextField,
  Select,
  MenuItem,
  Divider,
  Switch,
} from "@mui/material";
import CreatedSuccessfull from "./CreateClassLink/CreatedSuccessfully";

export let _id;

const mapStateToProps = (props) => ({
  inc: props.redres,
  dec: props.redres1,
});

const dateTransform = (par) => {
  try {
    let salute;
    let dateString = par.toString();
    let dateInfo = dateString.split(" ");
    let timeInfo = dateInfo[4].split(":");
    let hours = parseInt(timeInfo[0]);
    if (hours < 12 || hours === 24) {
      salute = "AM";
      if (hours === 0 || hours === 24) hours = 12;
    } else {
      salute = "PM";
      if (hours > 12) hours -= 12;
    }
    let formattedHours = hours < 10 ? "0" + hours : hours;
    let minutes = timeInfo[1];
    return `${formattedHours}:${minutes} ${salute}`;
  } catch (error) {
    console.log(error);
  }
};

const dateTransformLive = (parameter1) => {
  let dateString = parameter1.toString();
  let date = new Date(dateString);
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let day = ("0" + date.getDate()).slice(-2);
  return `${year}-${month}-${day}`;
};

const dayTransform = (parameter) => {
  let dayInfo = parameter.toString().split(" ")[0];
  const map = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
  };
  return map[dayInfo] || dayInfo;
};

const YoutubeLiveLink = ({
  event,
  inc,
  dec,
  setClick1,
  refetch2,
  SDate,
  EDate,
  click1,
  bookChapterList,
}) => {
  const {
    secSelectedOption,
    stdSelectedOption,
    teacherDCM,
    secSelectedOptionName,
    stdSelectedOptionName,
  } = useContext(SubStdSelContext);

  const [sucess, setSucess] = useState(false);
  const [createclassvariable, setCreateClassVariable] = useState({
    subjectName: "",
    description: "",
    joinmute: true,
    moderatorapproval: true,
    any_to_start_session: false,
    allasModerator: false,
    autojoin: false,
    modunmuteUser: false,
    disableprivatechat: true,
    audioCheck: true,
    listenMode: true,
    accessCode: false,
    welcomeMsg: "",
  });

  const [chapterId, setChapterId] = useState("");
  const [bookId, setBookId] = useState("");
  const [loadingChannels, setLoadingChannels] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [isToggled, setIsToggled] = useState({
    joinMute: createclassvariable.joinmute,
    moderatorApproval: createclassvariable.moderatorapproval,
    anyToStartSession: createclassvariable.any_to_start_session,
    allAsModerator: createclassvariable.allasModerator,
    autoJoin: createclassvariable.autojoin,
    modUnmuteUser: createclassvariable.modunmuteUser,
    disablePrivateChat: createclassvariable.disableprivatechat,
    AudioCheck: createclassvariable.audioCheck,
    ListenMode: createclassvariable.listenMode,
    AccessCode: createclassvariable.accessCode,
  });
  const [schoolId, setSchoolId] = useState("");
  const userINfo = JSON.parse(localStorage.getItem("UserInformation"));

  useEffect(() => {
    if (userINfo) {
      setSchoolId(userINfo?.school?.id);
    }
  }, [userINfo]);

  // ✅ Channel dropdown (dummy data for now)
  const [selectedChannel, setSelectedChannel] = useState("");
  const [channelList, setChannelList] = useState([]);

  const channelListApiCall = async () => {
    try {
      const response = await axios.get(
        `api/v1/videoConference/channels?school_id=${schoolId}`
      );

      setChannelList(response.data.data.channels);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingChannels(false);
    }
  };
  useEffect(() => {
    if (schoolId) {
      channelListApiCall();
    }
  }, [schoolId]);

  const handleAccessCode = () => {
    setCreateClassVariable({
      ...createclassvariable,
      accessCode: !createclassvariable.accessCode,
    });
  };
  const handleAudioCheck = () => {
    setCreateClassVariable({
      ...createclassvariable,
      audioCheck: !createclassvariable.audioCheck,
    });
  };
  const handleListenMode = () => {
    setCreateClassVariable({
      ...createclassvariable,
      ListenMode: !createclassvariable.ListenMode,
    });
  };
  const handleJoinMute = () => {
    setCreateClassVariable({
      ...createclassvariable,
      joinmute: !createclassvariable.joinmute,
    });
  };
  const handleModeratorApproval = () => {
    setCreateClassVariable({
      ...createclassvariable,
      moderatorapproval: !createclassvariable.moderatorapproval,
    });
  };
  const anyToStartSession = () => {
    setCreateClassVariable({
      ...createclassvariable,
      any_to_start_session: !createclassvariable.any_to_start_session,
    });
  };
  const allAsModerator = () => {
    setCreateClassVariable({
      ...createclassvariable,
      allasModerator: !createclassvariable.allasModerator,
    });
  };
  const autoJoin = () => {
    setCreateClassVariable({
      ...createclassvariable,
      autojoin: !createclassvariable.autojoin,
    });
  };
  const modUnmuteUser = () => {
    setCreateClassVariable({
      ...createclassvariable,
      modunmuteUser: !createclassvariable.modunmuteUser,
    });
  };
  const disablePrivateChat = () => {
    setCreateClassVariable({
      ...createclassvariable,
      disableprivatechat: !createclassvariable.disableprivatechat,
    });
  };
  const lecture_time = new Date(event.StartTime).toTimeString().slice(0, 5);
  const handleCreateClass = async () => {
    setIsLoading(true);
    let Teacher_Id = JSON.parse(localStorage.getItem("Teacher_id"));
    let newRes = {
      standard_id: stdSelectedOption,
      teacher_id: Teacher_Id,
      subject_id: event.Subject_id,
      section_id: secSelectedOption,
      name: createclassvariable.subjectName,
      description: createclassvariable.description,
      any_to_start_session: createclassvariable.any_to_start_session,
      join_as_moderator: createclassvariable.allasModerator,
      logo: `${IP}public/upload/logo/Logo.png`,
      record: true,
      mute_on_start: createclassvariable.joinmute,
      welcome_message: createclassvariable?.welcomeMsg,
      allow_mods_to_unmute_users: createclassvariable.modunmuteUser,
      wallpaper:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      dark_color: "#ffffff",
      logout_url:
        "https://cdn.pixabay.com/photo/2016/02/06/09/56/science-1182713_1280.jpg",
      light_color: "#7BDEFF",
      primary_color: "blue",
      meeting_layout: "SMART_LAYOUT",
      lock_settings_disable_private_chat:
        createclassvariable.disableprivatechat,
      require_moderator_approval: createclassvariable.moderatorapproval,
      auto_join: createclassvariable.autojoin,
      webcams_only_for_moderator: true,
      lockSettingsHideUserList: true,
      audioCheck: createclassvariable.audioCheck,
      listenMode: createclassvariable.listenMode,
      banner_color: "#00000",
      banner_text: "Breathe4School",
      duration: 0,
      selected_channel: selectedChannel, // ✅ Added here
      add_to_live_session: {
        lecture_id: event.Id,
        date: dateTransformLive(event?.StartTime),
      },
      channelId: selectedChannel,
      lecture_time: lecture_time,
    };

    if (chapterId?.trim()) newRes.chapter_id = chapterId;
    if (bookId?.trim()) newRes.book_id = bookId;

    try {
      const res = await axios.post(
        "/api/v1/videoConference/classes/createNotLink",
        newRes
      );
      if (res.data.status === true) {
        _id = res.data.data.id;
        setSucess(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const clickOk = () => {
    setClick1(false);
    refetch2(stdSelectedOption, secSelectedOption, SDate, EDate);
  };

  const [chapter1, setChapter1] = useState([]);
  const findChapterById = (array, id) => {
    const book = array.find((book) => book.id === id);
    setChapter1(book ? book.chapterData : []);
  };

  const isCreateDisabled =
    !createclassvariable.subjectName.trim() ||
    !createclassvariable.description.trim() ||
    !selectedChannel;

  const hasNoLiveChannels = !loadingChannels && channelList?.length === 0;

  return (
    <>
      <Dialog
        open
        onClose={() => setClick1(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: { borderRadius: "16px", overflow: "hidden" },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#FF6B00",
            color: "white",
            textAlign: "center",
            fontWeight: 600,
            py: 2,
          }}
        >
          Create Live BroadCast Stream
        </DialogTitle>

        <DialogContent dividers sx={{ p: { xs: 2, md: 3 } }}>
          {/* Header Info */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              p: 2,
              mb: 3,
              borderRadius: 2,
              bgcolor: "#F9FAFB",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                fontWeight: 500,
                color: "text.primary",
              }}
            >
              📘 {stdSelectedOptionName}-{secSelectedOptionName} | 📅{" "}
              {dayTransform(event?.StartTime)} | ⏰{" "}
              {dateTransform(event?.StartTime)} -{" "}
              {dateTransform(event?.EndTime)} | 📖 {event?.Subject} | 👨‍🏫{" "}
              {event?.TeacherName}
            </Typography>
          </Box>

          {hasNoLiveChannels && (
            <div
              className="d-flex flex-column align-items-center text-center mx-auto"
              style={{
                background: "#ffe5e5", // light red background
                color: "#b30000", // dark red text
                border: "1px solid #ffb3b3", // soft red border
                borderRadius: "10px",
                padding: "14px 18px",
                maxWidth: "600px",
                fontSize: "14px",
                fontWeight: 500,
                boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              }}
            >
              <i
                className="bi bi-exclamation-triangle-fill mb-1"
                style={{ fontSize: "22px", color: "#cc0000" }}
              ></i>

              <span>
                Your institution has not set up Live Channel for hosting live
                classes.
                <br />
                <strong>
                  Please contact your Institute Admin to configure the channel.
                </strong>
              </span>
            </div>
          )}

          {/* Class Name */}
          <Box className=" mb-3">
            <Typography variant="body2" fontWeight={600}>
              Class Name<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter Class Name"
              value={createclassvariable.subjectName}
              onChange={(event) =>
                setCreateClassVariable({
                  ...createclassvariable,
                  subjectName: event.target.value,
                })
              }
              sx={{ mt: 1 }}
            />
          </Box>

          {/* Description */}
          <Box className="mb-3">
            <Typography variant="body2" fontWeight={600}>
              Description<span style={{ color: "red" }}>*</span>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={2}
              placeholder="Enter session description"
              value={createclassvariable.description}
              onChange={(event) =>
                setCreateClassVariable({
                  ...createclassvariable,
                  description: event.target.value,
                })
              }
              sx={{ mt: 1 }}
            />
          </Box>

          {/* ✅ Channel Dropdown */}
          <Box className="mb-3">
            <Typography variant="body2" fontWeight={600}>
              Select Channel<span style={{ color: "red" }}>*</span>
            </Typography>

            <Select
              fullWidth
              displayEmpty
              value={selectedChannel}
              onChange={(e) => setSelectedChannel(e.target.value)}
              sx={{ mt: 1 }}
            >
              <MenuItem value="">Choose a Channel</MenuItem>

              {channelList.map((channel) => (
                <MenuItem key={channel.channelId} value={channel.channelId}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <img
                      src={channel.thumbnailUrl}
                      alt={channel.channelName}
                      style={{
                        width: 28,
                        height: 28,
                        borderRadius: "50%",
                      }}
                    />
                    {channel.channelName}
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </Box>

          {/* Book and Chapter */}
          <Box className="row mb-3">
            <div className="col-md-6">
              <Typography variant="body2" fontWeight={600}>
                Book
              </Typography>
              <Select
                fullWidth
                displayEmpty
                value={bookId}
                onChange={(e) => {
                  const selectedBookId = e.target.value;
                  setBookId(selectedBookId);
                  findChapterById(bookChapterList, selectedBookId);
                }}
                sx={{ mt: 1 }}
              >
                <MenuItem value="">Select Book</MenuItem>
                {bookChapterList.map((book) => (
                  <MenuItem key={book.id} value={book.id}>
                    {book.name}
                  </MenuItem>
                ))}
              </Select>
            </div>

            <div className="col-md-6">
              <Typography variant="body2" fontWeight={600}>
                Chapter
              </Typography>
              <Select
                fullWidth
                displayEmpty
                value={chapterId}
                onChange={(e) => setChapterId(e.target.value)}
                sx={{ mt: 1 }}
                disabled={!bookId}
              >
                <MenuItem value="">Select Chapter</MenuItem>
                {chapter1.length > 0 ? (
                  chapter1.map((ch) => (
                    <MenuItem key={ch.id} value={ch.id}>
                      {ch.chapterName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled>No chapters available</MenuItem>
                )}
              </Select>
            </div>
          </Box>

          {/* Welcome Message */}
          <Box className="mb-4">
            <Typography variant="body2" fontWeight={600}>
              Welcome Message
            </Typography>
            <TextField
              fullWidth
              placeholder="Enter welcome message"
              value={createclassvariable.welcomeMsg}
              onChange={(event) =>
                setCreateClassVariable({
                  ...createclassvariable,
                  welcomeMsg: event.target.value,
                })
              }
              sx={{ mt: 1 }}
            />
          </Box>

          {/* Toggles Section */}
          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" sx={{ color: "#FF6B00", mb: 2 }}>
            Session Settings
          </Typography>

          {[
            {
              label: "Mute users when they join",
              state: "joinMute",
              handler: handleJoinMute,
            },
            {
              label: "Require moderator approval before joining",
              state: "moderatorApproval",
              handler: handleModeratorApproval,
            },
            {
              label: "Enable any user to start this session",
              state: "anyToStartSession",
              handler: anyToStartSession,
            },
            {
              label: "All users join as moderators",
              state: "allAsModerator",
              handler: allAsModerator,
            },
            {
              label: "Automatically join me into the class",
              state: "autoJoin",
              handler: autoJoin,
            },
          ].map((item, i) => (
            <Box
              key={i}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <Typography>{item.label}</Typography>
              <Switch
                checked={isToggled[item.state]}
                onClick={() => {
                  setIsToggled({
                    ...isToggled,
                    [item.state]: !isToggled[item.state],
                  });
                  item.handler();
                }}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#FF6B00" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#FF6B00",
                  },
                }}
              />
            </Box>
          ))}

          <Divider sx={{ my: 3 }} />
          <Typography variant="h6" sx={{ color: "#FF6B00", mb: 2 }}>
            Advanced Settings
          </Typography>

          {[
            {
              label: "Enable moderator to unmute users",
              state: "modUnmuteUser",
              handler: modUnmuteUser,
            },
            {
              label: "Skip audio check",
              state: "AudioCheck",
              handler: handleAudioCheck,
            },
            {
              label: "Disable listen only mode",
              state: "ListenMode",
              handler: handleListenMode,
            },
            {
              label: "Enable user’s private chats",
              state: "disablePrivateChat",
              handler: disablePrivateChat,
            },
          ].map((item, i) => (
            <Box
              key={i}
              className="d-flex justify-content-between align-items-center mb-2"
            >
              <Typography>{item.label}</Typography>
              <Switch
                checked={isToggled[item.state]}
                onClick={() => {
                  setIsToggled({
                    ...isToggled,
                    [item.state]: !isToggled[item.state],
                  });
                  item.handler();
                }}
                sx={{
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#FF6B00" },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "#FF6B00",
                  },
                }}
              />
            </Box>
          ))}

          {/* Class Layout */}
          <Box className="mt-3">
            <Typography variant="body2" fontWeight={600}>
              Update Class Layout
            </Typography>
            <Select fullWidth sx={{ mt: 1 }}>
              <MenuItem value="0">SMART LAYOUT</MenuItem>
              <MenuItem value="1">VIDEO FOCUS</MenuItem>
              <MenuItem value="2">PRESENTATION FOCUS</MenuItem>
              <MenuItem value="3">CUSTOM LAYOUT</MenuItem>
            </Select>
          </Box>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setClick1(false)}
            variant="outlined"
            sx={{
              borderColor: "#FF6B00",
              color: "#FF6B00",
              "&:hover": { bgcolor: "#FF6B00", color: "white" },
              borderRadius: "10px",
            }}
          >
            Discard
          </Button>
          <Button
            onClick={handleCreateClass}
            variant="contained"
            disabled={isCreateDisabled || isLoading}
            sx={{
              bgcolor: isCreateDisabled ? "#ffbb80" : "#FF6B00",
              color: "white",
              "&:hover": {
                bgcolor: isCreateDisabled ? "#ffbb80" : "#e56a00",
              },
              borderRadius: "10px",
              cursor: isCreateDisabled ? "not-allowed" : "pointer",
            }}
          >
            {isLoading ? "Creating..." : "Create"}
          </Button>
        </DialogActions>
      </Dialog>

      {sucess && <CreatedSuccessfull onSucess={clickOk} />}
    </>
  );
};

export default connect(mapStateToProps)(YoutubeLiveLink);
